
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetoshirdicab() {



  const cardData =
  {
    keyword: ' Pune to Shirdi Cab',
    heading: 'SHREE Tours & Travels: Pune to Shirdi Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Pune to Shirdi Cab service, ensuring a comfortable and hassle-free journey to the sacred town of Sai Baba. Whether you are traveling for pilgrimage or leisure, our well-maintained Cabs and professional drivers provide a smooth ride. Enjoy a safe and convenient trip with flexible booking options and affordable fares. Choose SHREE Tours & Travels for a stress-free Pune to Shirdi travel experience.',

    top: 'Top Places to Visit in Shirdi with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shirdi Sai Baba Temple",
        "description": "The Shirdi Sai Baba Temple is the holiest and most visited place in Shirdi, attracting millions of devotees each year. Dedicated to Sai Baba, the temple complex houses his sacred Samadhi, where devotees offer prayers and seek blessings. The temple follows a strict schedule of Aartis and Bhajans, creating a divine and peaceful atmosphere. The best time to visit is during the Kakad Aarti in the early morning or the Shej Aarti at night for an immersive spiritual experience."
    },
    {
        "title": "Dwarkamai",
        "description": "Dwarkamai is one of the most revered sites in Shirdi, as it was the residence of Sai Baba for a significant part of his life. This simple yet sacred mosque is where he performed miracles, healed people and preached about love and humanity. Inside, visitors can see the sacred Dhuni (eternal fire) that Sai Baba lit, along with his wooden seat and a stone he used as a cushion. Dwarkamai is a must-visit for those who want to connect with Sai Baba’s life and teachings."
    },
    {
        "title": "Chavadi",
        "description": "Chavadi holds historical importance as Sai Baba used to rest here every alternate night during his later years. This small but sacred building preserves relics associated with him, including his wooden bed and palanquin. The temple hosts a grand procession every Thursday, recreating the way Sai Baba was taken to Chavadi with devotees singing and celebrating. The place carries a deep spiritual aura and is a must-visit for Sai Baba's followers."
    },
    {
        "title": "Gurusthan",
        "description": "Gurusthan is believed to be the place where Sai Baba was first seen in Shirdi as a young boy. A Neem tree here is said to have divine powers, with half its leaves being sweet and half bitter. A small shrine with a Shivling and a portrait of Sai Baba marks this spot and devotees light incense sticks to seek blessings. The calm and serene environment makes it an ideal place for meditation and reflection."
    },
    {
        "title": "Sai Heritage Village",
        "description": "Sai Heritage Village is a unique theme park that showcases the life and times of Sai Baba through lifelike statues and exhibits. Visitors can witness scenes from Sai Baba’s life, including his interactions with devotees, miracles and his simple way of living. The park also offers a fun toy train ride and a play area for children, making it a great spot for families to explore both spirituality and leisure in one visit."
    },
    {
        "title": "Khandoba Temple",
        "description": "Khandoba Temple is a historic temple dedicated to Lord Khandoba, where Sai Baba was first welcomed to Shirdi. This small yet significant temple is where Mahalsapati, the local priest, first recognized Sai Baba’s divine nature. The temple has idols of Lord Khandoba, Banai and Mhalsai and its peaceful surroundings make it a great place to sit and soak in the spiritual vibes."
    },
    {
        "title": "Lendi Baug",
        "description": "Lendi Baug is a beautiful garden where Sai Baba used to meditate daily. It contains a sacred lamp (Nanda Deep), which was lit by Sai Baba himself and continues to burn even today. The lush greenery, peaceful ambiance and fountains make it an ideal place for devotees to relax and reflect. The garden also features a Neem tree under which Sai Baba often rested, adding to its spiritual significance."
    },
    {
        "title": "Wet N Joy Water Park",
        "description": "For those looking to add some fun to their Shirdi trip, Wet N Joy Water Park is the perfect destination. This well-maintained amusement park offers thrilling water slides, a wave pool and a lazy river, making it a great spot for families and children. It’s an ideal place to unwind after a spiritual visit to the Sai Baba Temple."
    },
    {
        "title": "Dixit Wada Museum",
        "description": "Located near the Sai Baba Temple, Dixit Wada Museum displays rare artifacts, photographs and personal belongings of Sai Baba and his devotees. The museum gives visitors an insight into the simple life Sai Baba led, showcasing his robes, utensils and footwear. It is a must-visit for those who wish to learn more about his teachings and life."
    },
    {
        "title": "Shani Shingnapur",
        "description": "Located about 70 km from Shirdi, Shani Shingnapur is a unique village famous for its temple dedicated to Lord Shani. The village is known for its houses without doors, as people believe Lord Shani protects them from theft. The temple attracts thousands of devotees who come to offer prayers and perform rituals for good fortune and protection from evil. It is one of the most revered temples in Maharashtra and a great addition to any Shirdi itinerary."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Shirdi Taxi",
      "description": "Travel with comfort and convenience by booking a taxi from Pune to Shirdi with SHREE Tours & Travels. Our well-maintained vehicles and professional drivers ensure a smooth and hassle-free journey for your spiritual trip."
    },
    {
      "name": "Pune to Shirdi Cab Booking",
      "description": "Book a reliable and affordable Cab from Pune to Shirdi with SHREE Tours & Travels. We offer one-way and round-trip options, ensuring you have a stress-free travel experience to one of the most visited pilgrimage sites."
    },
    {
      "name": "Pune to Shirdi One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Shirdi? SHREE Tours & Travels offers convenient and cost-effective one-way taxi services, ensuring a comfortable and efficient ride to Shirdi without any hidden charges."
    },
    {
      "name": "Pune to Shirdi Round Trip Cab",
      "description": "Planning a round trip to Shirdi? Our round-trip Cab service offers flexibility for your return journey, whether it's the same day or a few days later, making your Shirdi trip easier and more convenient."
    },
    {
      "name": "Affordable Pune to Shirdi Cab",
      "description": "Get affordable taxi services from Pune to Shirdi without compromising on quality. Our budget-friendly Cabs provide a comfortable ride, making your pilgrimage trip both affordable and convenient."
    },
    {
      "name": "Private Taxi for Shirdi Temple from Pune",
      "description": "Experience the comfort of a private taxi from Pune to Shirdi Temple with SHREE Tours & Travels. Enjoy a peaceful and personal travel experience with our professional drivers and high-quality vehicles."
    },
    {
      "name": "Shirdi Temple Visit with Cab",
      "description": "Make your visit to Shirdi Temple even more special by booking a comfortable Cab. Our services include professional drivers who know the best routes, ensuring you reach your destination smoothly and on time."
    },
    {
      "name": "Shirdi Cab Hire",
      "description": "Hire a Cab from Pune to Shirdi with SHREE Tours & Travels. Choose from a range of vehicles, from budget options to luxury cars, ensuring you have a comfortable and personalized journey to the holy city."
    },
    {
      "name": "Group Travel for Shirdi from Pune",
      "description": "Traveling with a group? Our spacious and comfortable Cabs are perfect for group travel from Pune to Shirdi. Enjoy the journey together in a well-maintained vehicle with professional drivers."
    },
    {
      "name": "Book Pune to Shirdi Car",
      "description": "Rent a car for your journey from Pune to Shirdi with SHREE Tours & Travels. We offer a variety of vehicles including sedans, SUVs and more to ensure a comfortable and safe trip to the temple."
    },
    {
      "name": "Shirdi Tour by Cab",
      "description": "Plan your Shirdi temple visit with our convenient and reliable Cab service. Our drivers are familiar with the area and will ensure a comfortable ride, so you can focus on your spiritual journey."
    },
    {
      "name": "Shirdi Temple Taxi Service",
      "description": "Book a dedicated taxi service for your Shirdi Temple visit. With SHREE Tours & Travels, enjoy a hassle-free, safe and comfortable ride to the temple with experienced chauffeurs."
    },
    {
      "name": "Pune to Shirdi Cheap Taxi",
      "description": "Looking for a budget-friendly taxi from Pune to Shirdi? We offer reliable and affordable taxi options without compromising on comfort. Travel economically while enjoying a safe and smooth ride."
    },
    {
      "name": "Shirdi Trip from Pune",
      "description": "Book a Cab for your Shirdi trip from Pune with SHREE Tours & Travels. Our fleet of cars and professional drivers guarantee a pleasant and smooth journey to one of the most famous pilgrimage sites."
    },
    {
      "name": "Shirdi Cab for Family",
      "description": "Traveling with family? Our family-friendly Cabs ensure a safe, comfortable and memorable journey from Pune to Shirdi, with ample space for everyone and a smooth ride for all."
    },
    {
      "name": "Shirdi Sightseeing by Cab",
      "description": "Explore the key attractions around Shirdi with our sightseeing Cab service. Visit the famous Shirdi Sai Baba Temple and other local attractions in comfort with an experienced driver who knows the best routes."
    }
  ],

  "tableData": [
    ["- Pune to Shirdi Taxi", "- Pune to Shirdi Cab Booking"],
    ["- Pune to Shirdi One-Way Taxi", "- Pune to Shirdi Round Trip Cab"],
    ["- Affordable Pune to Shirdi Cab", "- Private Taxi for Shirdi Temple from Pune"],
    ["- Shirdi Temple Visit with Cab", "- Shirdi Cab Hire"],
    ["- Group Travel for Shirdi from Pune", "- Book Pune to Shirdi Car"],
    ["- Shirdi Tour by Cab", "- Shirdi Temple Taxi Service"],
    ["- Pune to Shirdi Cheap Taxi", "- Shirdi Trip from Pune"],
    ["- Shirdi Cab for Family", "- Shirdi Sightseeing by Cab"]
  ],

  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Shirdi Cabs are designed to offer you a comfortable and relaxing journey. With spacious seating, air-conditioning and smooth driving, you can enjoy a stress-free trip. Whether you're traveling for religious purposes or simply to explore, we ensure a pleasant experience throughout your ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the Pune to Shirdi route and are committed to providing you with a safe and timely trip. They prioritize your safety and comfort while ensuring a smooth journey. With their local expertise, you can trust that you’re in good hands during your trip."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and affordable pricing for your Pune to Shirdi Cab ride. With no hidden charges and transparent pricing, we guarantee great value without compromising on service quality. Whether you're booking a one-way or round trip, our pricing options ensure a budget-friendly solution."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to the highest standards, ensuring a smooth and safe journey. From cleanliness to mechanical performance, we take great care in keeping our fleet in top condition, providing you with a reliable and comfortable ride."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We understand that every traveler has different needs, which is why we offer flexible rental packages for your Pune to Shirdi trip. Whether you need a Cab for a few hours, a full day, or multiple days, we can customize the rental to meet your requirements and schedule."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab for your Pune to Shirdi trip is quick and easy with SHREE Tours & Travels. You can easily book online via our user-friendly platform or contact our customer service team for personalized assistance. Whether you're planning ahead or need a last-minute booking, we make the process hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Shirdi Cab needs. Whether you need an early morning ride or a late-night pickup, we are always here to accommodate your schedule. Our round-the-clock service ensures that we’re ready to serve you at any time."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers have extensive local knowledge and can provide useful insights into the best routes and attractions in and around Shirdi. If you're interested in sightseeing or need recommendations for places to visit, they are happy to share their expertise and enhance your journey."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "Customer satisfaction is our top priority at SHREE Tours & Travels. We are committed to providing exceptional service and ensuring that your Pune to Shirdi trip is comfortable, safe and enjoyable. With a focus on quality service and customer care, we guarantee a smooth and hassle-free experience."
    }
  ]
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Shirdi?",
        answer: "You can easily book your Pune to Shirdi Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Shirdi route?",
        answer: "We offer a variety of vehicles for the Pune to Shirdi journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Shirdi inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Shirdi?",
        answer: "Yes, we offer one-way rental options for your Pune to Shirdi trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Shirdi trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Shirdi Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Shirdi Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Shirdi trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Shirdi?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Shirdi?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Shirdi trip was fantastic! The driver was very professional and the ride was smooth and comfortable.',
        name: 'Mr. Sunil Deshmukh',
    },
    {
        text: 'I had a great experience with SHREE Tours & Travels. The ride to Shirdi was pleasant and the driver was extremely courteous.',
        name: 'Miss. Radhika Patil',
    }
];







  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Cab from Pune to Shirdi with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-shirdi-cab.jpg",
    "https://shreetoursandtravels.in/img/shirdi-temple-tour-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹5000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-shirdi-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.9,
    "reviewCount": 2200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Vinay Patil"
      },
      "datePublished": "2024-06-25",
      "reviewBody": "A divine experience! The trip to Shirdi was hassle-free and the driver was very polite. Highly recommend this service!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Neha Deshmukh"
      },
      "datePublished": "2024-07-10",
      "reviewBody": "Excellent service for the Shirdi temple visit. Comfortable and safe ride. Will definitely book again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Shirdi Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.7664,  // Shirdi latitude
      "longitude": 74.1867  // Shirdi longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-shirdi-cab-service"
  },
  "keywords": "Pune to Shirdi Taxi, Pune to Shirdi Cab Booking, Pune to Shirdi One-Way Taxi, Pune to Shirdi Round Trip Cab, Affordable Pune to Shirdi Cab, Private Taxi for Shirdi Temple from Pune, Shirdi Temple Visit with Cab, Shirdi Cab Hire, Group Travel for Shirdi from Pune, Book Pune to Shirdi Car, Shirdi Tour by Cab, Shirdi Temple Taxi Service, Pune to Shirdi Cheap Taxi, Shirdi Trip from Pune, Shirdi Cab for Family, Shirdi Sightseeing by Cab"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Shirdi Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Shirdi with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Shirdi Taxi, Pune to Shirdi Cab Booking, Pune to Shirdi One-Way Taxi, Pune to Shirdi Round Trip Cab, Affordable Pune to Shirdi Cab, Private Taxi for Shirdi Temple from Pune, Shirdi Temple Visit with Cab, Shirdi Cab Hire, Group Travel for Shirdi from Pune, Book Pune to Shirdi Car, Shirdi Tour by Cab, Shirdi Temple Taxi Service, Pune to Shirdi Cheap Taxi, Shirdi Trip from Pune, Shirdi Cab for Family, Shirdi Sightseeing by Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/6.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoshirdicab;